<script>


export default {
  components: {

  }
};
</script>

<template>
  <div id="login-wrapper">
    <slot />
  </div>
</template>
